import React from 'react';
import { cn } from '../../utils/classUtils';
import Button from '../Button';

interface SidebarModalActionFooterProps {
  submitButtonText?: string;
  cancelButtonText?: string;
  onClose(): void;
  isSubmitting: boolean;
  isDisabled?: boolean;
  onClick?(): void;
  buttonType?: 'submit' | 'button' | 'reset';
  SubmitButtonLeftIconComponent?: React.ReactElement;
  SubmitButtonRightIconComponent?: React.ReactElement;
  isEqualWidth?: boolean;
}

const SidebarModalActionFooter: React.FC<SidebarModalActionFooterProps> = ({
  submitButtonText = 'Save',
  cancelButtonText = 'Cancel',
  onClose,
  isSubmitting,
  isDisabled,
  onClick,
  buttonType = 'submit',
  isEqualWidth = false,
}) => (
  <div className='p-2 md:p-4 bg-white border-t border-gray-200 bottom-0 left-0 right-0 px-3 absolute py-2'>
    <div
      className={cn(
        'flex flex-row ml-auto justify-start items-center space-x-5',
        isEqualWidth ? 'w-full' : 'w-4/6',
      )}
    >
      <Button
        type='button'
        onPress={onClose}
        label={cancelButtonText}
        variant='primary-outline'
        buttonSize='sm'
        fullWidth
      />
      <Button
        isDisabled={isDisabled}
        isSubmitting={isSubmitting}
        type={buttonType}
        label={submitButtonText}
        onPress={onClick!}
        buttonSize='sm'
        fullWidth
      />
    </div>
  </div>
);

export default SidebarModalActionFooter;
